/* eslint-disable block-scoped-var, vars-on-top */
import axios from '@axios'

export default {
    namespaced: true,
    state: {
        solicitudes: [],
        solicitud: {},
        historialAprobaciones: [],
        plantillas: [],
        nivelAprobacion: [],
    },
    getters: {
        getSolicitudes(state) {
            return state.solicitudes
        },
        getSolicitud(state) {
            return state.solicitud
        },
        getHistorialAprobaciones(state) {
            return state.historialAprobaciones
        },
        getPlantillas(state) {
            return state.plantillas
        },
        getNivelAprobacion(state) {
            return state.nivelAprobacion
        },
    },
    mutations: {
        setSolicitudes(state, solicitudes) {
            state.solicitudes = solicitudes
        },
        setSolicitud(state, solicitud) {
            state.solicitud = solicitud
        },
        setHistorialAprobaciones(state, historialAprobaciones) {
            state.historialAprobaciones = historialAprobaciones
        },
        setPlantillas(state, plantillas) {
            state.plantillas = plantillas
        },
        setNivelAprobacion(state, nivelAprobacion) {
            state.nivelAprobacion = nivelAprobacion
        },
    },
    actions: {
        /* SOLICITUDES */
        fetchSolicitudes({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/licitaciones', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSolicitudes', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSolicitudesApproval({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/licitaciones/por-aprobar', {
                        params: data,
                    })
                    .then(response => {
                        commit('setSolicitudes', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSolicitudById({ commit }, id_solicitud, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/licitaciones/${id_solicitud}`, { params: data })
                    .then(response => {
                        commit('setSolicitud', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearSolicitud(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm('/api/auth/licitaciones', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarSolicitud(_, { id_solicitud, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/licitaciones/${id_solicitud}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        preAprobarSolicitudes(_, { id_solicitud, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/licitaciones/${id_solicitud}/pre-aprobacion`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        aprobarSolicitudes(_, { id_solicitud, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/licitaciones/${id_solicitud}/aprobacion`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* CORREOS */
        fetchSubirArchivo(_, { id_solicitud, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/licitaciones/${id_solicitud}/reporte`, payload)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        enviarCorreoCategoria(_, payload) {
            if (typeof payload === 'object') var { id_solicitud, ...data } = payload
            else {
                // eslint-disable-next-line no-redeclare
                var id_solicitud = payload
                // eslint-disable-next-line no-redeclare
                var data = {}
            }

            const url = `/api/auth/licitaciones/${id_solicitud ? `${id_solicitud}/` : ''}enviar-correo-pre-aprobado`
            return new Promise((resolve, reject) => {
                axios
                    .post(url, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        enviarCorreoPendiente(_, id_solicitud) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/licitaciones/${id_solicitud}/enviar-correo-pendiente`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        enviarCorreoAprobado(_, payload) {
            if (typeof payload === 'object') var { id_solicitud, ...data } = payload

            const url = `/api/auth/licitaciones/${id_solicitud ? `${id_solicitud}/` : ''}enviar-correo-aprobado`
            return new Promise((resolve, reject) => {
                axios
                    .post(url, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        enviarCorreoRechazado(_, id_solicitud) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/licitaciones/${id_solicitud}/enviar-correo-rechazado`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        enviarCorreoAnulado(_, id_solicitud) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/licitaciones/${id_solicitud}/enviar-correo-anulado`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        enviarCorreoMasivo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/licitaciones/enviar-correo-masivo', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchHistorialAprobaciones({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/licitaciones/niveles-aprobacion/historial-aprobacion', {
                        params: data,
                    })
                    .then(response => {
                        commit('setHistorialAprobaciones', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* PLANTILLAS */
        fetchPlantillas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/licitaciones/plantillas', {
                        params: data,
                    })
                    .then(response => {
                        commit('setPlantillas', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPlantillaById({ commit }, id_plantilla) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/licitaciones/plantillas/${id_plantilla}`)
                    .then(response => {
                        commit('setPlantillas', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearPlantilla(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/licitaciones/plantillas', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarPlantilla(_, { id_plantilla, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/licitaciones/plantillas/${id_plantilla}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarPlantilla(_, id_plantilla) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/licitaciones/plantillas/${id_plantilla}`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDescargarArchivo(_, id_solicitud) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/licitaciones/${id_solicitud}/reporte`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* NIVELES DE APROBACIÓN */
        fetchResponsablesSolicitudes(_, filter) {
            return axios.get('/api/auth/licitaciones/niveles-aprobacion/responsables', {
                params: filter,
            })
        },

        postNivelAprobacion(_, data) {
            return axios.post('/api/auth/licitaciones/niveles-aprobacion', data)
        },

        fetchUpdateNivelAprobacion(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .patch(`api/auth/licitaciones/niveles-aprobacion/${data.id_configuracion}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarNivelAprobacion(_, id_configuracion) {
            return axios.delete(`/api/auth/licitaciones/niveles-aprobacion/${id_configuracion}`)
        },

        fetchNivelesAprobacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('api/auth/licitaciones/niveles-aprobacion', { params: data })
                    .then(response => {
                        commit('setNivelAprobacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCreateNivelesAprobacion(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('api/auth/licitaciones/niveles-aprobacion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
